export const colors = [
    {
        variant: "building",
        mode: "solid",
        alpha: false,
        class: ["bg-utility-gray-400", "fg-white"],
    },
    {
        variant: "building",
        mode: "solid",
        alpha: true,
        class: ["bg-alpha-black-40", "fg-white"],
    },
    {
        variant: "building",
        mode: "transparent",
        class: [
            "bg-utility-gray-200",
            "text-utility-gray-400",
            "group-data-[state=checked]:bg-utility-gray-400",
            "group-data-[state=checked]:fg-white",
        ],
    },
    {
        variant: "space",
        mode: "solid",
        class: ["bg-utility-blue-light-400", "fg-white"],
    },
    {
        variant: "space",
        mode: "transparent",
        class: ["bg-utility-blue-light-100", "text-utility-blue-light-400"],
    },
    {
        variant: ["asset", "asset_group"],
        mode: "solid",
        class: ["bg-utility-orange-400", "fg-white"],
    },
    {
        variant: ["asset", "asset_group"],
        mode: "transparent",
        class: ["bg-utility-orange-100", "text-utility-orange-400"],
    },
    {
        variant: "category",
        mode: "transparent",
        class: ["bg-utility-indigo-100", "text-utility-indigo-500"],
    },

    {
        variant: "category",
        mode: "solid",
        class: ["bg-utility-indigo-500", "fg-white"],
    },
    {
        variant: "tag",
        mode: "transparent",
        class: ["bg-utility-blue-100", "text-utility-blue-500"],
    },
    {
        variant: "tag",
        mode: "solid",
        class: ["bg-utility-blue-500", "fg-white"],
    },
    {
        variant: ["folder"],
        mode: "solid",
        class: ["bg-utility-gray-400", "fg-white"],
    },
    {
        variant: ["folder"],
        mode: "transparent",
        class: ["bg-quaternary", "fg-quinary"],
    },
    {
        variant: "files",
        mode: "solid",
        class: ["bg-utility-success-500", "fg-white"],
    },
    {
        variant: "files",
        mode: "transparent",
        class: ["bg-utility-success-100", "text-utility-success-400"],
    },

    {
        variant: ["tasks", "recurring-tasks"],
        mode: "transparent",
        class: ["bg-utility-brand-50", "text-utility-brand-600"],
    },
    {
        variant: ["tasks", "recurring-tasks"],
        mode: "solid",
        class: ["bg-utility-brand-600", "fg-white"],
    },
    {
        variant: "layout",
        mode: "transparent",
        class: ["bg-utility-blue-light-100", "text-utility-brand-700_alt"],
    },
    {
        variant: "layout",
        mode: "solid",
        class: ["bg-utility-brand-700_alt", "fg-white"],
    },
    {
        variant: "info",
        mode: "transparent",
        class: ["bg-utility-gray-200", "text-utility-gray-400"],
    },
    {
        variant: "info",
        mode: "solid",
        class: ["bg-utility-gray-400", "fg-white"],
    },
    {
        variant: "users",
        mode: "transparent",
        class: ["bg-utility-blue-light-100", "text-utility-blue-400"],
    },
    {
        variant: "users",
        mode: "solid",
        class: ["bg-utility-blue-400", "fg-white"],
    },
    {
        variant: "roles",
        mode: "transparent",
        class: ["bg-utility-warning-100", "text-utility-warning-400"],
    },
    {
        variant: "roles",
        mode: "solid",
        class: ["bg-utility-warning-400", "fg-white"],
    },
    {
        variant: "flow",
        mode: "transparent",
        class: ["bg-utility-purple-100", "text-utility-gray-blue-500"],
    },
    {
        variant: "flow",
        mode: "solid",
        class: ["bg-utility-gray-blue-500", "fg-white"],
    },
    {
        variant: "passports",
        mode: "transparent",
        class: ["bg-utility-purple-100", "text-utility-purple-500"],
    },
    {
        variant: "passports",
        mode: "solid",
        class: ["bg-utility-purple-500", "fg-white"],
    },
    {
        variant: "qr-code",
        mode: "transparent",
        class: ["bg-quaternary", "fg-quaternary"],
    },
    {
        variant: "qr-code",
        mode: "solid",
        class: ["bg-[#667085]", "fg-white"],
    },
    {
        variant: ["information", "checklist_item"],
        mode: "transparent",
        class: ["bg-utility-blue-50", "text-utility-blue-600"],
    },
    {
        variant: "information",
        mode: "solid",
        class: ["bg-utility-blue-500", "fg-white"],
    },
];
